import { init as initConfig } from '@cian/config/browser';
import { init as initLogger } from '@cian/logger/browser';
import { init as initTelemetry, setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi, setup as setupHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initMicrofrontend } from '@cian/mf-registry/browser';

export const setupDependencies = () => {
  setupTelemetry();
  setupHttpApi({});
};

export const initDependencies = () => {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initMicrofrontend();
};
